import { createFileRoute } from '@tanstack/react-router';
import { PersonSegmentsRoute } from './-route-wrappers';

/** The person profile's Segments tab, Doesn't belong to, at its own URL. */
function PersonSegmentsOthersRoute() {
  const { personId } = Route.useParams();

  return <PersonSegmentsRoute personId={personId} view="others" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/segments/others')({
  component: PersonSegmentsOthersRoute,
});
